$(window).on('load', () => {
  const $onPageNav = $('[data-onpage-navigation]');
  console.log($onPageNav.length);
  if ($onPageNav.length) {
    const $navItems = $onPageNav.find('a');
    $navItems.each((index, item) => {
      const $item = $(item);
      $item.removeClass('is-active');
      // Check if the href matches the current page path
      if ($item.attr('href') === window.location.pathname) {
        $item.addClass('is-active');
      }
    });
  }
});
